import { MinuteViewCell } from "../types";

/**
 * * Сгенерировать список MinuteViewCell для выбора минут
 * @returns
 */
export const generateMinuteItems = (
  interval: number = 15
): MinuteViewCell[] => {
  return Array.from({ length: Math.round(60 / interval) }, (_, index) => ({
    minute: index * interval,
    text: (index * interval).toString().padStart(2, "0"),
  }));
};
